import React from "react";
import {FormControl} from "react-bootstrap";
import util from "./../../lib/util.js";

export default class FreetimePicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inputs: {}
        };
        
        this.onChange = this.onChange.bind(this);
    }

    onChange() {
        if (this.props.onChange) this.props.onChange();
    }

    getValue() {
        let textVal = this.state.inputs.textInput.value;
        let ampmVal = this.state.inputs.ampmInput.value;

        textVal = util.fromalizeTimeText(textVal);

        let result = util.convertTo24h(textVal, ampmVal);
        this.state.inputs.textInput.value = result ? textVal : "";                 

        return result;
    }

    setValue(val) {
        const decomposed = convert(val);

        this.state.inputs.textInput.value = decomposed.time;
        this.state.inputs.ampmInput.value = decomposed.ampm;
    }

    convert(s24h) {
        const ampmTime = util.convertToAMPM(s24h);
        const decomposed = util.decomposeAMPM(ampmTime);
        return decomposed;
    }

    render() {
        const self = this;
        let decomposed = {
            time: "",
            ampm: "AM"
        }

        if (this.props.time) {
            decomposed = this.convert(this.props.time);
        }

        return(
            <div className="ap-unwrap-content">
                <FormControl className="ap-inline ap-halfsize" inputRef={node => self.state.inputs.textInput = node}
                    onBlur={this.onChange} defaultValue={decomposed.time}
                    placeholder="hh:mm" />
                    &nbsp;
                    <FormControl componentClass="select" className="ap-inline ap-halfsize" defaultValue={decomposed.ampm}
                    onBlur={this.onChange}
                    inputRef={node => self.state.inputs.ampmInput = node}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                </FormControl>
            </div>
            );
    }
}